(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const originalDurations = new WeakMap();
  let durationRevision = 0;
  const prepare = (root) => {
    root.querySelectorAll('xo-carousel').forEach((carousel) => {
      const list = carousel.querySelector(':scope > xo-carousel-inner > xo-carousel-list');
      if (list?.children.length === 1) {
        carousel.dataset.npsSingleSlide = '';
        carousel.setAttribute('xo-type', 'slide');
      }
    });
    root.querySelectorAll('xo-animate, xo-animate-item, [xo-animate="scroll"]').forEach((node) => {
      const bounds = node.getBoundingClientRect();
      if (bounds.top < window.innerHeight && bounds.bottom > 0 && !node.closest('xo-modal, xo-popover, xo-toggle')) {
        node.dataset.npsImmediate = '';
        if (node.localName === 'xo-animate') node.setAttribute('xo-disabled', 'true');
      }
    });
    root.querySelectorAll('xo-collapse, xo-modal, xo-popover, xo-carousel').forEach((node) => {
      const previousDuration = node.getAttribute('xo-duration');
      if (!originalDurations.has(node)) originalDurations.set(node, previousDuration);
      if (reduced.matches) node.setAttribute('xo-duration', '0');
      else {
        const original = originalDurations.get(node);
        if (original === null) node.removeAttribute('xo-duration');
        else node.setAttribute('xo-duration', original);
      }
      if (node.localName === 'xo-collapse' && customElements.get('xo-collapse') && previousDuration !== node.getAttribute('xo-duration')) {
        node.setAttribute('xo-observed', `nps-motion-${++durationRevision}`);
      }
    });
  };
  prepare(document);
  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
  reduced.addEventListener?.('change', () => prepare(document));

  // Native carousel thumbnails otherwise treat every key (including Tab) as a click.
  document.addEventListener('keydown', (event) => {
    if (!(event.target instanceof Element)) return;
    const control = event.target.closest('xo-carousel-bullet, xo-carousel-thumbnail xo-carousel-slide');
    if (!control || event.defaultPrevented) return;
    event.stopPropagation();
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    if (!event.repeat) control.click();
  }, { capture: true });
})();

(() => {
  const source = document.currentScript;
  if (!source) return;
  const requested = new Set(Array.from(document.scripts, (script) => script.src));
  const loadScript = (url) => {
    if (!url) return;
    const absolute = new URL(url, document.baseURI).href;
    if (requested.has(absolute)) return;
    requested.add(absolute);
    const script = document.createElement('script');
    script.src = absolute;
    script.addEventListener('error', () => {
      requested.delete(absolute);
      script.remove();
    }, { once: true });
    document.head.append(script);
  };
  const has = (root, selector) => root.matches?.(selector) || root.querySelector?.(selector);
  const prepareComponents = (root) => {
    if (has(root, '.nps-sticky-cart-docked, .nps-detail-pills')) {
      if (source.dataset.npsProductCss && !document.getElementById('nps-product-components')) {
        const style = document.createElement('link');
        style.id = 'nps-product-components';
        style.rel = 'stylesheet';
        style.href = source.dataset.npsProductCss;
        style.addEventListener('error', () => style.remove(), { once: true });
        document.head.append(style);
      }
      if (has(root, '.nps-sticky-cart-docked')) loadScript(source.dataset.npsStickyJs);
    }
    if (has(root, '.nps-product-gallery-mobile')) loadScript(source.dataset.npsGalleryJs);
  };
  prepareComponents(document);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1) prepareComponents(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (event) => prepareComponents(event.target));
})();
